'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _appToolbar = require('./app-toolbar.html');

var _appToolbar2 = _interopRequireDefault(_appToolbar);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

exports.default = {
  templateUrl: _appToolbar2.default,
  transclude: {
    toolbarButtonsLeft: 'toolbarButtonsLeft',
    toolbarButtonsRight: 'toolbarButtonsRight'
  },
  controller: function ToolbarComponent() {
    'ngInject';

    _classCallCheck(this, ToolbarComponent);
  }
};


// WEBPACK FOOTER //
// ./components/app/common/app-toolbar/app-toolbar.component.js